import { InputBase } from 'components/UI/input/elements/input-base';
import { InputRange } from 'components/UI/input/elements/input-range';

import cm from 'classnames';
import styles from './_title-credits.module.scss';

interface Props {
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  params: {
    min: number;
    max: number;
    step: number;
  };
  className?: string;
}

export const __Slider = ({ value, onChange, params, className }: Props) => {
  return (
    <div className={cm(styles.Slider, className)}>
      <InputRange className={styles.Slider__range} onChange={onChange} value={value} {...params} />
      <InputBase type="number" className={styles.Slider__input} onChange={onChange} value={value} {...params} />
    </div>
  );
};
